import { FC } from 'react';

import { IconProps } from './types';

export const DownArrowIcon: FC<IconProps> = ({ color = '#14489D' }) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="12" height="7">
		<path
			fill={color}
			transform="translate(0 1.90735e-06)"
			d="M10.246 0.29100001C10.059 0.104 9.8050003 0 9.5410004 0C9.2770004 0 9.0229998 0.104 8.8360004 0.29100001L5.2459998 3.8310001L1.706 0.29100001C1.5190001 0.104 1.265 0 1.001 0C0.73699999 0 0.48300001 0.104 0.296 0.29100001C0.20200001 0.384 0.12800001 0.49399999 0.077 0.616C0.026000001 0.73799998 0 0.86900002 0 1.001C0 1.133 0.026000001 1.263 0.077 1.385C0.12800001 1.507 0.20200001 1.618 0.296 1.711L4.5359998 5.9510002C4.6290002 6.0440001 4.7399998 6.119 4.8610001 6.1700001C4.9829998 6.2199998 5.1139998 6.2459998 5.2459998 6.2459998C5.3779998 6.2459998 5.5089998 6.2199998 5.631 6.1700001C5.7519999 6.119 5.8629999 6.0440001 5.9559999 5.9510002L10.246 1.711C10.34 1.618 10.414 1.507 10.465 1.385C10.516 1.263 10.542 1.133 10.542 1.001C10.542 0.86900002 10.516 0.73799998 10.465 0.616C10.414 0.49399999 10.34 0.384 10.246 0.29100001Z"
		/>
	</svg>
);
